import { MOBILE_WIDTH_MAX } from "@/constants"

import { PANEL_MIN_WIDTH, PANEL_MOBILE_MIN_WIDTH } from "./constants"

const DESKTOP_DRAWER_MAX_VIEWPORT_RATIO = 0.8
const DEFAULT_MAIN_CONTENT_MIN_WIDTH = 640
const AGENT_PLAYGROUND_MAIN_CONTENT_MIN_WIDTH = 420

const AGENT_PLAYGROUND_PATH_RE = /^\/workspaces\/[^/]+\/agents\/[^/]+$/

const getMinMainContentWidth = (pathname: string): number => {
  if (AGENT_PLAYGROUND_PATH_RE.test(pathname)) {
    return AGENT_PLAYGROUND_MAIN_CONTENT_MIN_WIDTH
  }

  return DEFAULT_MAIN_CONTENT_MIN_WIDTH
}

export const getCopilotDrawerMinWidth = (viewportWidth: number): number => {
  if (viewportWidth < MOBILE_WIDTH_MAX) {
    return Math.min(PANEL_MOBILE_MIN_WIDTH, viewportWidth)
  }

  return PANEL_MIN_WIDTH
}

export const getCopilotDrawerMaxWidth = ({
  pathname,
  viewportWidth,
}: {
  pathname: string
  viewportWidth: number
}): number => {
  if (viewportWidth <= 0) {
    return PANEL_MIN_WIDTH
  }

  if (viewportWidth < MOBILE_WIDTH_MAX) {
    return viewportWidth
  }

  const viewportLimitedWidth = Math.floor(
    viewportWidth * DESKTOP_DRAWER_MAX_VIEWPORT_RATIO
  )
  const layoutLimitedWidth = viewportWidth - getMinMainContentWidth(pathname)

  return Math.max(
    PANEL_MIN_WIDTH,
    Math.min(viewportLimitedWidth, layoutLimitedWidth)
  )
}

export const clampCopilotDrawerWidth = ({
  desiredWidth,
  pathname,
  viewportWidth,
}: {
  desiredWidth: number
  pathname: string
  viewportWidth: number
}): number => {
  const maxWidth = getCopilotDrawerMaxWidth({ pathname, viewportWidth })
  const minWidth = Math.min(getCopilotDrawerMinWidth(viewportWidth), maxWidth)

  return Math.max(minWidth, Math.min(maxWidth, desiredWidth))
}
